import React from "react";
import { Input, Label } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera } from "@fortawesome/free-solid-svg-icons";
import "./styles.css";

export default function ChatInput({
  uploadPicture,
  message,
  handleChangeChatMessage,
  handleSubmit,
  activeChat
}) {
  return (
    <div className="input-container">
      {activeChat.currentConsultId.status !== "requested" &&
        activeChat.currentConsultId.status !== "finished" && (
          <>
            <Label for="input-image" className="mb-1">
              <FontAwesomeIcon icon={faCamera} color="#41414d" />
            </Label>
            <Input
              type="file"
              id="input-image"
              accept="image/png, image/jpg"
              onChange={e => uploadPicture(e, activeChat)}
            />
            <Input
              type="text"
              placeholder="Digite uma mensagem..."
              value={message}
              onChange={e => handleChangeChatMessage(e.target.value)}
            />
            <Input type="submit" value="Enviar" onClick={handleSubmit} />
          </>
        )}
      {activeChat.currentConsultId.status === "requested" && (
        <p>Aguardando aceite da solicitação</p>
      )}
      {activeChat.currentConsultId.status === "finished" && (
        <p>Consulta finalizada</p>
      )}
    </div>
  );
}
